<template>
  <label class="file-select">
    <!-- We can't use a normal button element here, as it would become the target of the label. -->
    <div class="select-button">
      <!-- Display the filename if a file has been selected. -->
      <span v-if="filename">Selected File: {{ filename }}</span>
      <span v-else>{{ heading }}</span>

      <div class="progressbar" v-if="progressBarValue > 0 && progressBarValue < 100">
        <div :style="{width: `${progressBarValue}%`}">
          <span>{{ progressBarValue }} %</span>
        </div>
      </div>
      

    </div>
    <!-- Now, the file input that we hide. -->
    <input type="file" @change="handleFileChange"/>

    
  </label>
</template>

<script>
import FileUploadsService from '../../services/file-uploads.service'
import axios from 'axios';

const mimeTypes = [
   { ext: ['jpeg', 'jpg'], mimetype: 'image/jpeg'},
   { ext: ['png'], mimetype: 'image/png'},
   { ext: ['cdr'], mimetype: 'application/octet-stream'},
]
  export default {
     data(){
       return {
         signedurl: '',
         progressBarValue: 0,
         filename: ''
       }
     },
     props: {
        // Using value here allows us to be v-model compatible.
        value: String,
        heading: {
          type: String,
          default: 'Upload File'
        }
      },
     
      methods: {
       async handleFileChange(e) {
          // Whenever the file changes, emit the 'input' event with the file data.
          this.filename = e.target.files[0].name
          const mimeForFile = e.target.files[0] ? this.detectMimeType(e.target.files[0].name) : ''
          

          if(mimeForFile){

             this.signedurl = await this.generatePresignedUrl(mimeForFile, e.target.files[0].name.replace(/ /g,"_"))
             
             if(this.signedurl){

                 var options = {
                      headers: {
                        'Content-Type': mimeForFile,
                      },
                      onUploadProgress: progressEvent => {
                        if (progressEvent.lengthComputable) {
                            console.log(progressEvent.loaded + ' ' + progressEvent.total);
                             this.progressBarValue = this.updateProgressBarValue(progressEvent);
                          }
                      }
                    };

                const upload = await axios.put(this.signedurl, e.target.files[0], options)
                
                this.$emit('input', this.getPathFromUrl(this.signedurl))
                console.log('file uploaded', upload)
             }else{
                console.log('Failed to generate signed url')
             }
             
             


          }


          
          

        },
        detectMimeType(fileName){
           const ext = fileName.split('.').pop();
           const mime = mimeTypes.find(file => file.ext.includes(ext))
           return mime.mimetype;
        },
        async generatePresignedUrl(mimeType, fileName){
           try{
              const result = await FileUploadsService.generateS3PresignedUrl({mimeType, fileName})

              return result.data.url;
           }catch(errors){
              console.log(errors.response.data)
           }
        },
        updateProgressBarValue(event){
           return Math.ceil((event.loaded / event.total) * 100);
        },
        getPathFromUrl(url) {
            return url.split("?")[0];
        }
      }
  }
</script>

<style lang="scss" scoped>
.file-select{
  display: block;
}
.file-select > .select-button {
  padding: 5px 10px;
  color: #15bd6c;
  border: 1px solid #15bd6c;
  cursor: pointer;
  border-radius: .3rem;
  position: relative;
  display: block;
  text-align: center;
  font-weight: bold;
}

/* Don't forget to hide the original file input! */
.file-select > input[type="file"] {
  display: none;
}
.progressbar{
  height: 30px;
  position: relative;
  overflow: hidden;
  div{
    background-color: #15bd6c;
    width: 100%;
    height: 5px;
    position: absolute;
    bottom: 0;

    span{
      position: absolute;
      bottom: 3px;
      font-size: 13px;
      right: 0;
      white-space: nowrap;
    }
  }
  
}
</style>